import { mapState, mapGetters, mapActions } from 'vuex'

export const memberListAgentadminComputed = {
  ...mapState('memberListAgentadmin', {
    loading: (state) => state.loading,
  }),
  ...mapGetters('memberListAgentadmin', [
    'getMemberListAgent',
    'getOverviewMember',
  ]),
}

export const memberListAgentadminMethods = mapActions('memberListAgentadmin', [
  'fetchingOverviewMember',
  'fetchingMemberListAgent',
  'resetMemberList',
  'exportMemberListAgentCsv',
  'fetchingChartData',
  'fetchingStatus',
  'changeStatusMember',
  'unbindMember',
])
